<div class="nxt-podcast">
  <section class="nxt-hero" aria-labelledby="nxt-hero-title">
    <h1 id="nxt-hero-title" class="nxt-sr-only">
      {{ "nxtPodcast.hero.title" | translate }}
    </h1>

    <picture>
      <source
        type="image/webp"
        srcset="
          /assets/img/nxt-podcast/hero-nxt-podcast-1600.webp 1600w,
          /assets/img/nxt-podcast/hero-nxt-podcast-2560.webp 2560w
        "
        sizes="100vw"
      />
      <img
        class="nxt-hero__img"
        src="/assets/img/nxt-podcast/hero-nxt-podcast-1600.jpg"
        srcset="
          /assets/img/nxt-podcast/hero-nxt-podcast-1600.jpg 1600w,
          /assets/img/nxt-podcast/hero-nxt-podcast-2560.jpg 2560w
        "
        sizes="100vw"
        width="2560"
        height="1440"
        fetchpriority="high"
        [attr.alt]="'nxtPodcast.hero.imgAlt' | translate"
      />
    </picture>

    <div class="nxt-hero__overlay"></div>

    <div class="nxt-hero__content">
      <picture>
        <source
          type="image/webp"
          srcset="/assets/img/nxt-podcast/nxt-podcast-logo-900.webp"
        />
        <img
          class="nxt-hero__logo"
          src="/assets/img/nxt-podcast/nxt-podcast-logo-900.png"
          width="900"
          height="420"
          alt=""
        />
      </picture>
      <p class="nxt-hero__tagline">
        {{ "nxtPodcast.hero.tagline" | translate }}
      </p>
    </div>

    <a
      class="nxt-hero__scroll"
      href="#nxt-about"
      (click)="scrollToAbout($event)"
      [attr.aria-label]="'nxtPodcast.hero.scrollLabel' | translate"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M4 8l8 8 8-8"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </a>
  </section>

  <section class="nxt-about" id="nxt-about" aria-labelledby="nxt-about-title">
    <div class="nxt-container nxt-about__grid">
      <div class="nxt-stack">
        <span
          class="nxt-stack__shape nxt-stack__shape--yellow"
          aria-hidden="true"
        ></span>
        <span
          class="nxt-stack__shape nxt-stack__shape--navy"
          aria-hidden="true"
        ></span>
        <picture>
          <source
            type="image/webp"
            srcset="
              /assets/img/nxt-podcast/about-nxt-podcast-800.webp   800w,
              /assets/img/nxt-podcast/about-nxt-podcast-1400.webp 1400w
            "
            sizes="(max-width: 900px) 92vw, 45vw"
          />
          <img
            class="nxt-stack__img"
            src="/assets/img/nxt-podcast/about-nxt-podcast-800.jpg"
            srcset="
              /assets/img/nxt-podcast/about-nxt-podcast-800.jpg   800w,
              /assets/img/nxt-podcast/about-nxt-podcast-1400.jpg 1400w
            "
            sizes="(max-width: 900px) 92vw, 45vw"
            width="1400"
            height="934"
            loading="lazy"
            decoding="async"
            [attr.alt]="'nxtPodcast.about.imgAlt' | translate"
          />
        </picture>
      </div>

      <div class="nxt-about__copy">
        <p class="nxt-eyebrow">{{ "nxtPodcast.about.eyebrow" | translate }}</p>
        <h2 class="nxt-h2" id="nxt-about-title">
          {{ "nxtPodcast.about.title" | translate }}
        </h2>
        <p class="nxt-body">{{ "nxtPodcast.about.body1" | translate }}</p>
        <p class="nxt-body">{{ "nxtPodcast.about.body2" | translate }}</p>
      </div>
    </div>
  </section>

  <section class="nxt-host" aria-labelledby="nxt-host-title">
    <div class="nxt-container nxt-host__grid">
      <div class="nxt-host__copy">
        <h2 class="nxt-h2 nxt-h2--yellow" id="nxt-host-title">
          {{ "nxtPodcast.host.title" | translate }}
        </h2>
        <p class="nxt-body nxt-body--light">
          {{ "nxtPodcast.host.body1" | translate }}
        </p>
        <p class="nxt-body nxt-body--light">
          {{ "nxtPodcast.host.body2" | translate }}
        </p>
      </div>

      <div class="nxt-stack nxt-stack--host">
        <span
          class="nxt-stack__shape nxt-stack__shape--yellow"
          aria-hidden="true"
        ></span>
        <picture>
          <source
            type="image/webp"
            srcset="
              /assets/img/nxt-podcast/giancarlo-nicastro-700.webp   700w,
              /assets/img/nxt-podcast/giancarlo-nicastro-1200.webp 1200w
            "
            sizes="(max-width: 900px) 92vw, 45vw"
          />
          <img
            class="nxt-stack__img"
            src="/assets/img/nxt-podcast/giancarlo-nicastro-700.jpg"
            srcset="
              /assets/img/nxt-podcast/giancarlo-nicastro-700.jpg   700w,
              /assets/img/nxt-podcast/giancarlo-nicastro-1200.jpg 1200w
            "
            sizes="(max-width: 900px) 92vw, 45vw"
            width="1200"
            height="1200"
            loading="lazy"
            decoding="async"
            [attr.alt]="'nxtPodcast.host.imgAlt' | translate"
          />
        </picture>
      </div>
    </div>
  </section>

  <section
    class="nxt-episodes"
    *ngIf="episodes.length"
    aria-labelledby="nxt-episodes-title"
  >
    <div class="nxt-container">
      <h2 class="nxt-h2 nxt-h2--center" id="nxt-episodes-title">
        {{ "nxtPodcast.episodes.title" | translate }}
      </h2>

      <div class="nxt-carousel">
        <button
          class="nxt-carousel__arrow nxt-carousel__arrow--prev"
          type="button"
          [attr.aria-label]="'nxtPodcast.episodes.prevLabel' | translate"
          aria-controls="nxt-track"
          [disabled]="isAtStart"
          (click)="scrollPrev()"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              d="M15 4l-8 8 8 8"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>

        <ul
          class="nxt-carousel__track"
          id="nxt-track"
          #track
          role="list"
          tabindex="0"
          lang="pt-BR"
          [attr.aria-label]="'nxtPodcast.episodes.listLabel' | translate"
          (scroll)="onTrackScroll()"
        >
          <li class="nxt-card" *ngFor="let episode of episodes">
            <button
              class="nxt-card__link"
              type="button"
              [attr.aria-label]="episodeAriaLabel(episode)"
              (click)="openEpisode(episode, $event.currentTarget)"
            >
              <div class="nxt-card__thumb">
                <img
                  [src]="thumbUrl(episode)"
                  [attr.alt]="episode.title"
                  loading="lazy"
                  decoding="async"
                  width="400"
                  height="225"
                />
                <span class="nxt-card__play" aria-hidden="true">
                  <svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z" /></svg>
                </span>
                <span class="nxt-card__duration">{{ episode.duration }}</span>
              </div>
              <div class="nxt-card__body">
                <h3 class="nxt-card__title">{{ episode.title }}</h3>
                <p class="nxt-card__guest">{{ episode.guest }}</p>
                <p class="nxt-card__role">{{ episode.role }}</p>
              </div>
            </button>
          </li>
        </ul>

        <button
          class="nxt-carousel__arrow nxt-carousel__arrow--next"
          type="button"
          [attr.aria-label]="'nxtPodcast.episodes.nextLabel' | translate"
          aria-controls="nxt-track"
          [disabled]="isAtEnd"
          (click)="scrollNext()"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              d="M9 4l8 8-8 8"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </section>
  <section class="nxt-platforms" aria-labelledby="nxt-platforms-title">
    <span
      class="nxt-platforms__bar nxt-platforms__bar--yellow"
      aria-hidden="true"
    ></span>
    <span
      class="nxt-platforms__bar nxt-platforms__bar--navy"
      aria-hidden="true"
    ></span>

    <div class="nxt-container">
      <h2 class="nxt-h2 nxt-h2--center" id="nxt-platforms-title">
        {{ "nxtPodcast.platforms.title" | translate }}
      </h2>

      <ul class="nxt-platforms__list" role="list">
        <li>
          <a
            class="nxt-platform"
            [href]="playlistUrl"
            target="_blank"
            rel="noopener"
            data-analytics="nxt-platform-youtube"
          >
            <img
              src="/assets/img/nxt-podcast/youtube_horizontal.png"
              [attr.alt]="'nxtPodcast.platforms.youtube' | translate"
              width="160"
              height="40"
              loading="lazy"
              onerror="this.remove()"
            />
            <span class="nxt-platform__fallback">YouTube</span>
          </a>
        </li>
        <li>
          <a
            class="nxt-platform"
            href="https://open.spotify.com/show/41Cd3FdI244CGxwAGqlnZ7"
            target="_blank"
            rel="noopener"
            data-analytics="nxt-platform-spotify"
          >
            <img
              src="/assets/img/nxt-podcast/Spotify_horizontal.png"
              [attr.alt]="'nxtPodcast.platforms.spotify' | translate"
              width="160"
              height="40"
              loading="lazy"
              onerror="this.remove()"
            />
            <span class="nxt-platform__fallback">Spotify</span>
          </a>
        </li>
        <li>
          <a
            class="nxt-platform"
            href="https://music.amazon.com.br/podcasts/490a6c09-c4ca-461b-8d3e-a260cf1fa787/nxt-podcast"
            target="_blank"
            rel="noopener"
            data-analytics="nxt-platform-amazon"
          >
            <img
              src="/assets/img/nxt-podcast/Amazon_Horizontal.png"
              [attr.alt]="'nxtPodcast.platforms.amazon' | translate"
              width="160"
              height="40"
              loading="lazy"
              onerror="this.remove()"
            />
            <span class="nxt-platform__fallback">Amazon Music</span>
          </a>
        </li>
        <li>
          <a
            class="nxt-platform"
            href="https://www.deezer.com/br/show/1001629411"
            target="_blank"
            rel="noopener"
            data-analytics="nxt-platform-deezer"
          >
            <img
              src="/assets/img/nxt-podcast/deezer_horizontal.png"
              [attr.alt]="'nxtPodcast.platforms.deezer' | translate"
              width="160"
              height="40"
              loading="lazy"
              onerror="this.remove()"
            />
            <span class="nxt-platform__fallback">Deezer</span>
          </a>
        </li>
      </ul>
    </div>
  </section>

  <app-btn-up></app-btn-up>

  <div
    class="nxt-modal"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'nxtPodcast.player' | translate"
    [hidden]="!activeVideoId"
    (click)="onBackdropClick($event)"
  >
    <button
      #modalClose
      class="nxt-modal__close"
      type="button"
      [attr.aria-label]="'nxtPodcast.closePlayer' | translate"
      (click)="closeModal()"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M5 5l14 14M19 5L5 19"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
        />
      </svg>
    </button>
    <div class="nxt-modal__frame">
      <iframe
        *ngIf="safeEmbedUrl"
        [src]="safeEmbedUrl"
        [attr.title]="'nxtPodcast.player' | translate"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
    <div class="nxt-modal__actions" *ngIf="activeVideoId">
      <span class="nxt-modal__hint">
        {{ "nxtPodcast.fallback.hint" | translate }}
      </span>
      <a
        class="nxt-modal__action nxt-modal__action--primary"
        [href]="activeWatchUrl"
        target="_blank"
        rel="noopener"
        data-analytics="nxt-fallback-watch-youtube"
      >
        {{ "nxtPodcast.fallback.watchOnYoutube" | translate }}
      </a>
    </div>
  </div>
</div>
